import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEdiCustomerLookup extends Layout {
    sourceEdiCustomer: DataSource;
    tableCustomerLookup: Table;
}
